import { EllipsisVerticalIcon, EnvelopeIcon } from "@heroicons/react/24/outline"
import { useEffect, useState } from "react"
import ModalMenuItem from "../../modal-menu-item"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import ModalUpdateLicenses from "../../modal-update-licenses"
import { TextQtd } from "../../../../medias/components/tailwind/item-table/styled"


const ItemTable = (props) => {

    // const [visibleMenu, setvisibleMenu] = useState(false)
    const [visibleModal, setVisibleModal] = useState(false)
    const dispatch = useDispatch()
    const [visibleModalMenu, setvisibleModalMenu] = useState(false)
    const history = useHistory()

    useEffect(() => {
        console.log("props item", props)
    }, [])

    const [visibleModalUpdate, setVisibleModalUpdate] = useState(false)

    const reducerDeleteLicenses = useSelector((state) => state.reducerDeleteLicenses);
    const language = useSelector((state) => state.reducerLanguage);


    useEffect(() => {
        if (reducerDeleteLicenses.loading == false && reducerDeleteLicenses.error == false && reducerDeleteLicenses?.data?.length == 0) {

        } else {
            const id = "reducerDeleteLicenses"
            if (reducerDeleteLicenses.loading) {
                //toast.loading(translations["Aguarde..."][language.data], { toastId: id })
            } else {
                if (reducerDeleteLicenses.error) {

                }
                //toast.update(id, { render: "Erro ao tentar excluír.", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
                else {
                    //toast.update(id, { render: "Excluído com sucesso", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
                    //props.setVisible(false)
                    //props.goSearch()
                    //dispatch({ type: "LICENSES_DELETE_RESET" })
                    setVisibleModalUpdate(false)
                }
            }
        }
    }, [reducerDeleteLicenses])

    return (
        <>
            <ModalMenuItem setVisibleModalUpdate={setVisibleModalUpdate} goSearch={props.goSearch} setVisibleModalEdit={setVisibleModal} item={props.item} visible={visibleModalMenu} setVisibleModal={setvisibleModalMenu} />
            <ModalUpdateLicenses goSearch={props.goSearch} item={props.item} visible={visibleModalUpdate} setVisible={setVisibleModalUpdate} />
            <tr key={"person.email"} className={props.selectedOrders.includes(props.item) ? 'bg-gray-50 even:bg-gray-50' : "even:bg-gray-50"}>
                <td className="relative px-7 sm:w-12 sm:px-6">
                    {props.selectedOrders.includes(props.item) && (
                        <div className="absolute inset-y-0 left-0 w-0.5 bg-green-600" />
                    )}
                    <input
                        type="checkbox"
                        className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        value={props.item.email}
                        checked={props.selectedOrders.includes(props.item)}
                        onChange={(e) =>
                            props.setSelectedOrders(
                                e.target.checked
                                    ? [...props.selectedOrders, props.item]
                                    : props.selectedOrders.filter((p) => p !== props.item),
                            )
                        }
                    />
                </td>
                <td
                    className={props.classNames(
                        'whitespace-nowrap py-4 pr-3 text-sm font-medium',
                        props.selectedOrders.includes(props.item) ? 'text-gray-900' : 'text-gray-900',
                    )}
                >
                    {new Date(props.item.created_at).toLocaleDateString()}
                </td>

                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {props.item.name}
                </td>

                <td className="whitespace-nowrap text-center px-3 py-4 text-sm text-gray-500">
                    <TextQtd onClick={() => { history.push(`/licencas/${props.item.id}/codigos?used=0`) }} >
                        {props.item.not_used_codes}
                    </TextQtd>
                </td>
                <td className="whitespace-nowrap text-center px-3 py-4 text-sm text-gray-500">
                    <TextQtd onClick={() => { history.push(`/licencas/${props.item.id}/codigos?used=1`) }} >
                        {props.item.used_codes}
                    </TextQtd>
                </td>
                {/* <td className="whitespace-nowrap text-center px-3 py-4 text-sm text-gray-500">
                    <TextQtd onClick={() => { history.push(`/licencas/${props.item.id}/codigos`) }} >
                        {props.item.total_codes}
                    </TextQtd>
                </td> */}
                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3">
                    <span style={{ position: "relative" }}>
                        <EllipsisVerticalIcon onClick={() => { setvisibleModalMenu(true); }} style={{ height: "32px", cursor: "pointer" }} />
                    </span>
                </td>
            </tr >
        </>

    )
}

export default ItemTable